import { Component, OnInit } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { FilterDescriptor, orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { CartItem, ICartItem, ICartReviewsLbl, IFilterItemRequest } from 'src/app/core/models';
import { CartService } from '../../../core/services/cart.service';
import { CheckoutService } from '../../../core/services/checkout.service';
import { UserService } from '../../../core/services/user.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';

@Component({
  selector: 'app-cart-review',
  templateUrl: './cart-review.component.html',
  styleUrls: ['./cart-review.component.scss']
})  
export class CartReviewComponent implements OnInit {
  cartReviewTxt: ICartReviewsLbl;
  //userId = '';
  constructor(
    private cartService: CartService,
    private checkoutService: CheckoutService,
    private userService: UserService, private languageTranslationService: LanguageTranslationService
  ) {  }

  public cartview: GridDataResult;
  public gridData: ICartItem[] = [];
  private getItemListBody: IFilterItemRequest = {
    customerNumber:'',
    itemNumber: '',
    longItemNumber: '',
    pageNo: 1,
    searchQuery: '',
    skip: 0,
    take: 1,
    finishFilter: [],
    categoryFilter: [],
    sort: [
      {
        field: '',
        dir: 'asc',
      },
    ],
    filter: []
  };

  protected gridState: State = {
    sort: [
      {
        field: 'lineNumber',
        dir: 'asc',
      },
    ],
    skip: 0,
    take: 10,
    group: [],
  };

  ngOnInit(): void {
    this.loadLanguageTranslationData();
    this.cartService.getItems1().subscribe((r: ICartItem[]) => {     
      this.gridData = r;      
      this.bindReviewGridData();
      if(r.length>0){
        this.checkoutService.checkoutformState.isRCFormValid = true;
        // this.checkoutService.checkOutProcessModel.orderDetail.
        this.checkoutService.checkOutProcessModel.orderTotal = this.cartItemsTotal;
      }

    });

    this.freightAmountChangeSubscription = this.checkoutService.freightAmountChangeSubject.subscribe(val => {
      //handle freight update here if aapplicable
      console.log('Subscription received the freight amount-->', val);
      this.checkoutService.checkOutProcessModel.freightAmount = Number(val);
      this.freightEstimatedShipping;
    })

    //Validate CC Customer
    if (this.userService.isCheckoutCCCustomer())
      this.checkOutCCCustomer = true;
    else if (this.userService.isCheckoutCConlyCustomer())
      this.checkOutCConlyCustomer = true;
    if (this.userService.getFreightEstimateFlag())
      this.freightEstimateFlag = true;
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      {controlName: "gridTextLbl1"},
      { controlName: "gridTextLbl2" },
      { controlName: "gridTextLbl3" },
      { controlName: "gridTextLbl4" },
      { controlName: "gridTextLbl5" },
      { controlName: "finishLbl" },
      { controlName: "sizeLbl" },
      { controlName: "quantityLbl" },
      { controlName: "paintLbl" },
      { controlName: "uomLbl" },     
      { controlName: "lineLbl" },
      { controlName: "itemLbl" },
      { controlName: "unitLbl" },
      { controlName: "extrusionLbl" },
      { controlName: "descriptionLbl" },
      { controlName: "listPriceLbl" },
      { controlName: "multiplierLbl" },
      { controlName: "unitPriceLbl" },
      { controlName: "extendedPriceLbl" },
      { controlName: "totalPriceLbl" },
     
    ];
    const componentName = "cartreview";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.cartReviewTxt = response[response.length - 1];
      console.log(response);
    }

  }


  //#endregion


  //#region label declaration
  protected cartReview = {
    gridTextLbl1: '* Applicable States Sales Tax will be added after the order is processed.',
    gridTextLbl2: '* Shipping Charge will be calculated at the time of order  processing.',
    gridTextLbl3: '* All painted orders will be invoiced at a minimum of $500.00  net per color.',   
    gridTextLbl4: '* Shipping costs are estimated and is subject to change',
    gridTextLbl5: '* Shipping costs may still be applicable for Pickup orders if material is not stocked at the pickup facility',
    finishLbl: 'Finish',
    paintLbl: 'Paint',
    sizeLbl: 'Size',
    quantityLbl: 'Quantity',
    uomLbl: 'UoM',   
    lineLbl: 'Line #',
    unitLbl: 'Unit',
    itemLbl: 'Item #',
    extrusionLbl: 'Extrusion',
    descriptionLbl: 'Description',
    listPriceLbl: 'List Price',
    multiplierLbl: 'Multiplier',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    totalPriceLbl: 'Total Price',
    
  }
  //#endregion


  public bindReviewGridData() { 
    this.cartview = process(this.gridData, this.gridState); 
  }
  //#region pagination
  public reviewPageChange({ skip, take }: PageChangeEvent) {    
    this.gridState.skip = skip;
    this.gridState.take = take;
    this.bindReviewGridData();
  }

  protected cartReviewGridSortChange(sort): void {
    this.gridState.sort = sort;
    this.bindReviewGridData();
  }
 
  //#endregion
  protected updateTotalCartItem(): number {
    if (this.cartview) {
      if (this.cartview.data) {
        return this.cartview.data.length as number;
      }
    }

    return 0;
  }



  public get cartItemsTotal(): number {
    if (this.cartview) {
      if (this.gridData) {
        return (this.gridData as CartItem[]).map(
          item => item.extendedPrice //item.basePrice * item.quantity * item.cmp * 0.94 // discount factor
        ).reduce((a, b) => +(a + b).toFixed(2), 0);
      }
    }
    return 0;
  }
  getExtendedPrice(dataItem: CartItem): number {  
    dataItem.extendedPrice = dataItem.basePrice * dataItem.cmp * dataItem.quantity * 0.94;
    return dataItem.extendedPrice;
  }

  //#region Freight Calc Region
  public freightAmountChangeSubscription;
  public checkOutCConlyCustomer: boolean = false;
  public checkOutCCCustomer: boolean = false;
  public prepaidFreightSelected: boolean = false;
  public freightEstimateFlag: boolean = false;
  public get freightEstimatedShipping(): number {
    this.prepaidFreightSelected = this.checkoutService.prepaidFreightSelected;
    if (this.checkoutService.checkOutProcessModel.freightAmount) {
      return this.checkoutService.checkOutProcessModel.freightAmount;
    }
    return 0;
  }
  //#endregion
}
